

function Gallery() {
    return (
      <>
        <section className="picture">
          <div className="bottles square"></div>
          <div className="org-slice square"></div>
          <div className="cones square"></div>
          <div className="cubes square"></div>
        </section>
      </>
    );
}

export default Gallery;